export const convertCelsiusToFahrenheit = (celsius: number | null | undefined) => {
    if (celsius == null) {
      return null;
    }
    return Math.round(((celsius * 9) / 5 + 32) * 10) / 10;
};
  
export const convertFahrenheitToCelsius = (fahrenheit: number | null | undefined) => {
    if (fahrenheit == null) {
      return null;
    }
    return Math.round(((fahrenheit - 32) * 5) / 9 * 10) / 10;
};
  

export const convertCelsiusToFahrenheitOffset = (celsius: number | null | undefined) => {
    if (celsius == null) {
      return null;
    }
    return Math.round(((celsius * 9) / 5) * 10) / 10;
};
  
export const convertFahrenheitToCelsiusOffset = (fahrenheit: number | null | undefined) => {
    if (fahrenheit == null) {
      return null;
    }
    return Math.round(((fahrenheit) * 5) / 9 * 10) / 10;
};